import { useState } from "react";
import { NavLink } from "react-router-dom";
import { LuPanelLeftClose, LuPanelRightClose } from "react-icons/lu";

import {
  DashboardIcon,
  ESGIcon,
  BusinessIcon,
  MasterDataIcon,
  ProjectsIcon,
  ServicesIcon,
  PartnersIcon,
  AssetsIcon,
  BillingIcon,
  DocumentsIcon,
  FolderIcon,
  LegalIcon,
  NotificationsIcon,
  CockpitSettingsIcon,
} from "../../../shared/cockpit/components/icons/Icon";
import "./CockpitSideTabs.scss";

function CockpitSideTabs() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuGroups = [
    {
      id: "group1",
      title: "Portfolio",
      items: [
        {
          name: "Cockpit",
          path: "/app/cockpit/cockpit",
          icon: <DashboardIcon />,
          color: "#4a90e2",
        },
        {
          name: "ESG & CO2",
          path: "/app/cockpit/nachhaltigkeit-und-pflichten",
          icon: <ESGIcon />,
          color: "#7ed321",
        },
      ],
    },
    {
      id: "group2",
      title: "Stammdaten",
      items: [
        {
          name: "Gesellschaften",
          path: "/app/cockpit/gesellschaften",
          icon: <BusinessIcon />,
          color: "#4a90e2",
        },
        {
          name: "Objekte",
          path: "/app/cockpit/objekte",
          icon: <MasterDataIcon />,
          color: "#4a90e2",
        },
      ],
    },
    {
      id: "group3",
      title: "Operations",
      items: [
        {
          name: "Projekte",
          path: "/app/cockpit/projekte",
          icon: <ProjectsIcon />,
          color: "#f5a623",
        },
        {
          name: "Leistungen & Board",
          path: "/app/cockpit/leistungen-und-board",
          icon: <ServicesIcon />,
          color: "#9013fe",
        },
        {
          name: "Partner & Dienstleister",
          path: "/app/cockpit/partner-und-dienstleister",
          icon: <PartnersIcon />,
          color: "#46d2b4",
        },
      ],
    },
    {
      id: "group4",
      title: "Betrieb",
      items: [
        {
          name: "Aktive Anlagen",
          path: "/app/cockpit/aktive-anlagen",
          icon: <AssetsIcon />,
          color: "#f8e71c",
        },
        {
          name: "Abrechnung & Mieter",
          path: "/app/cockpit/abrechnung-und-mieter",
          icon: <BillingIcon />,
          color: "#7ed321",
        },
      ],
    },
    {
      id: "group5",
      title: "Verwaltung",
      items: [
        {
          name: "Vertragsmanagement",
          path: "/app/cockpit/vertragsmanagement",
          icon: <DocumentsIcon />,
          color: "#d0021b",
        },
        {
          name: "Dokumente & Freigaben",
          path: "/app/cockpit/dokumente-und-freigaben",
          icon: <FolderIcon />,
          color: "#f5a623",
        },
      ],
    },
    {
      id: "group6",
      title: "System",
      items: [
        {
          name: "Legal & Tax",
          path: "/app/cockpit/recht-und-steuern",
          icon: <LegalIcon />,
          color: "#4a90e2",
        },
        {
          name: "Mitteilungen",
          path: "/app/cockpit/mitteilungen",
          icon: <NotificationsIcon />,
          color: "#4a90e2",
        },
        {
          name: "Einstellungen",
          path: "/app/cockpit/einstellungen",
          icon: <CockpitSettingsIcon />,
          color: "#4a90e2",
        },
      ],
    },
  ];

  return (
    <nav className={`cockpit-side-tabs ${isCollapsed ? "cockpit-side-tabs--collapsed" : ""}`}>
      <div className="cockpit-side-tabs__menu">
        <button
          type="button"
          className="cockpit-side-tabs__toggle"
          onClick={() => setIsCollapsed((prev) => !prev)}
          title={isCollapsed ? "Ausklappen" : "Einklappen"}
          aria-label={isCollapsed ? "Sidebar ausklappen" : "Sidebar einklappen"}
          aria-expanded={!isCollapsed}
        >
          {isCollapsed ? <LuPanelRightClose /> : <LuPanelLeftClose />}
          {!isCollapsed && " Einklappen"}
        </button>

        <div className="cockpit-side-tabs__group-container">
          {menuGroups.map((group) => (
            <div key={group.id} className="cockpit-side-tabs__group">
              {group.title && (
                <div className="cockpit-side-tabs__group-title">
                  {group.title}
                </div>
              )}
              <div className="cockpit-side-tabs__items">
                {group.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `cockpit-side-tabs__item ${
                        isActive ? "cockpit-side-tabs__item--active" : ""
                      }`
                    }
                    title={isCollapsed ? item.name : undefined}
                    aria-label={item.name}
                  >
                    <span
                      className="cockpit-side-tabs__item-icon"
                      style={{ color: item.color }}
                    >
                      {item.icon}
                    </span>
                    {!isCollapsed && (
                      <span className="cockpit-side-tabs__item-name">
                        {item.name}
                      </span>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default CockpitSideTabs;
